import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { EVENT_NAME } from '../constants';
import { EventProps } from '../analytics.types';

export interface ScreenshotData {
  id: string;
  dataUrl: string;
}

export type ExportAnalyticsEvent = {
  eventName: EVENT_NAME | string;
  props: EventProps;
  screenshotIndex?: number;
};

interface LocalLogStore {
  localLog: ExportAnalyticsEvent[];
  screenshots: ScreenshotData[];
  clearAndResetLog: () => void;
  pushEvent: (event: ExportAnalyticsEvent) => void;
  pushScreenshot: (screenshot: ScreenshotData) => void;
}

// Store to track state for local event log
export const localLogStore = create<LocalLogStore>()(
  persist(
    (set, get) => ({
      // Initial state
      localLog: [],
      screenshots: [],

      // Actions
      clearAndResetLog: () => {
        // Clear the persisted Zustand state from local storage
        localStorage.removeItem('local-user-event-log');
        set(() => ({
          localLog: [],
          screenshots: [],
        }));
      },
      pushEvent: (event: ExportAnalyticsEvent) => {
        const currentLog = get().localLog;
        set({ localLog: [...currentLog, event] });
      },
      pushScreenshot: (screenshot: ScreenshotData) => {
        const currentScreenshots = get().screenshots;
        set({ screenshots: [...currentScreenshots, screenshot] });
      },
    }),

    // Persist the state in localStorage so it lasts between refreshes
    {
      // key in localStorage for the persisted state
      name: 'local-user-event-log',
      storage: createJSONStorage(() => localStorage),
      // Persist both localLog and screenshots (not the actions)
      partialize: (state) => ({
        localLog: state.localLog,
        screenshots: state.screenshots,
      }),
    },
  ),
);
